export function resolveMatchCountdownTargetUnix(primaryUnix, fallbackUnix = 0) {
    const a = Number(primaryUnix);
    if (Number.isFinite(a) && a > 0) return Math.floor(a);
    const b = Number(fallbackUnix);
    if (Number.isFinite(b) && b > 0) return Math.floor(b);
    return 0;
}

export function computeRemainingSecondsUntilUnix(targetUnix, nowSeconds = null) {
    const now = nowSeconds ?? Math.floor(Date.now() / 1000);
    if (!targetUnix) return 0;
    return Math.max(0, targetUnix - now);
}

export function formatMatchCountdownHMS(remainingSeconds) {
    const sec = Math.max(0, Math.floor(Number(remainingSeconds) || 0));
    const hours = String(Math.floor(sec / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((sec % 3600) / 60)).padStart(2, "0");
    const seconds = String(sec % 60).padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
}
